"use client";

import { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProductPreview() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    }
  }, []);
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const collaborationsEn = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plastic_injection_molding.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plastic_injection_molding.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plastic_injection_molding.png-wvc-sizes",
    alt: "Precision plastic injection molding process",
    edition: "R&D Focused",
    title: "Precision *Injection* Molding",
    detail: "High-speed automated production lines for complex plastic components."
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_toy_assembly.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_toy_assembly.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_toy_assembly.webp-wvc-sizes",
    alt: "Hand-stitched plush toy assembly line",
    edition: "Quality Assured",
    title: "Artisanal *Plush* Assembly",
    detail: "Expert hand-stitching and quality control for soft consumer goods."
  }, {
    src: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/07/ISSO-Logo.png?v=3xfux8e6c3i",
    srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/07/ISSO-Logo.png?v=azynubq1mzd-wvc-srcset",
    sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/07/ISSO-Logo.png?v=p6et4f3u4d-wvc-sizes",
    alt: "Rigorous safety and compliance testing",
    edition: "Certified Safe",
    title: "Global *Compliance* Standards",
    detail: "Full certification support including BV, ITS, SGS, and TUV-R."
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/odm_product_showcase.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/odm_product_showcase.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/odm_product_showcase.png-wvc-sizes",
    alt: "Showcase of ODM product development",
    edition: "Market Ready",
    title: "Custom *ODM* Solutions",
    detail: "End-to-end product development from initial concept to market launch."
  }];
  const collaborationsZh = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plastic_injection_molding.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plastic_injection_molding.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plastic_injection_molding.png-wvc-sizes",
    alt: "Precision plastic injection molding process",
    edition: "專注研發",
    title: "精密 *注塑* 成型",
    detail: "高速自動化生產線，專門製造複雜塑膠組件。"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_toy_assembly.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_toy_assembly.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_toy_assembly.webp-wvc-sizes",
    alt: "Hand-stitched plush toy assembly line",
    edition: "品質保證",
    title: "精湛 *毛絨* 組裝",
    detail: "專業手工縫製與嚴格品質把控，打造高品質軟性消費品。"
  }, {
    src: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/07/ISSO-Logo.png?v=3xfux8e6c3i",
    srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/07/ISSO-Logo.png?v=azynubq1mzd-wvc-srcset",
    sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/07/ISSO-Logo.png?v=p6et4f3u4d-wvc-sizes",
    alt: "Rigorous safety and compliance testing",
    edition: "安全認證",
    title: "全球 *合規* 標準",
    detail: "提供全面認證支援，涵蓋 BV、ITS、SGS 及 TUV-R。"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/odm_product_showcase.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/odm_product_showcase.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/odm_product_showcase.png-wvc-sizes",
    alt: "Showcase of ODM product development",
    edition: "市場就緒",
    title: "客製化 *ODM* 方案",
    detail: "從最初概念到市場推出的端到端產品開發。"
  }];
  const collaborations = isZh ? collaborationsZh : collaborationsEn;
  const renderTitle = (title: string) => {
    const parts = title.split(/(\*[^*]+\*)/g);
    return parts.map((part, idx) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        return <em key={idx} className="italic font-serif">
            {part.slice(1, -1)}
          </em>;
      }
      return <span key={idx}>{part}</span>;
    });
  };
  return <section data-section-id="17492" id="product-excellence-preview" className="bg-background text-foreground py-32 md:py-44 px-5 md:px-8 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <div ref={header.ref} className={`mx-auto max-w-[760px] text-center mb-20 md:mb-24 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <p className="font-default uppercase text-primary" style={{
          fontSize: "12px",
          letterSpacing: "0.22em",
          fontWeight: 500
        }}>
            {isZh ? "卓越製造工藝" : "Manufacturing Excellence"}
          </p>
          <h2 className="font-default font-semibold text-foreground mt-5" style={{
          fontSize: "clamp(2rem, 3.6vw, 3.5rem)",
          letterSpacing: "-0.015em",
          lineHeight: 1.06
        }}>
            {isZh ? <>
                精工製造，<em className="italic font-serif">符合全球</em> 標準。
              </> : <>
                Engineered <em className="italic font-serif">for global</em> standards.
              </>}
          </h2>
          <p className="font-default text-foreground/80 mt-4 mx-auto" style={{
          fontSize: "clamp(0.9375rem, 0.95vw, 1rem)",
          lineHeight: 1.65
        }}>
            {isZh ? "Elite Group Corporation Limited 提供全方位 OEM/ODM 服務，確保每款產品均符合嚴格的國際安全與品質標準。" : "Elite Group Corporation Limited provides comprehensive OEM/ODM services, ensuring every product meets rigorous international safety and quality benchmarks."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-20 md:gap-y-24">
          {collaborations.map((item, i) => {
          return <CollaborationPlate key={i} index={i} item={item} renderTitle={renderTitle} />;
        })}
        </div>
      </div>
    </section>;
}
function CollaborationPlate({
  index,
  item,
  renderTitle
}: {
  index: number;
  item: {
    src: string;
    srcset: string;
    sizes: string;
    alt: string;
    edition: string;
    title: string;
    detail: string;
  };
  renderTitle: (title: string) => React.ReactNode;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const delay = index * 140;
  return <div data-index={index} ref={ref} className="group p-8 md:p-14 border border-border" style={{
    transitionDelay: `${delay}ms`
  }}>
      <div className="overflow-hidden">
        <div className="aspect-[3/2] w-[70%] mx-auto overflow-hidden transition-all ease-out" style={{
        transitionDuration: "1200ms",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "scale(1)" : "scale(1.04)",
        transitionDelay: `${delay}ms`
      }}>
          <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform ease-out group-hover:scale-[1.03]" style={{
          transitionDuration: "600ms"
        }} />
        </div>
      </div>

      <div className="mt-8 flex flex-col items-start text-left transition-all ease-out" style={{
      transitionDuration: "700ms",
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(12px)",
      transitionDelay: `${delay + 200}ms`
    }}>
        <p className="font-default uppercase text-primary" style={{
        fontSize: "12px",
        letterSpacing: "0.22em",
        fontWeight: 500
      }}>
          {item.edition}
        </p>
        <h3 className="font-default font-semibold text-foreground mt-3 relative inline-block" style={{
        fontSize: "clamp(1.375rem, 1.9vw, 1.875rem)",
        letterSpacing: "-0.01em",
        lineHeight: 1.15
      }}>
          <span className="relative">
            {renderTitle(item.title)}
            <span className="absolute left-0 -bottom-1 h-px bg-primary transition-all ease-out group-hover:w-full w-0" style={{
            transitionDuration: "400ms"
          }} />
          </span>
        </h3>
        <p className="font-default text-foreground/70 mt-3" style={{
        fontSize: "clamp(0.75rem, 0.8vw, 0.8125rem)",
        letterSpacing: "0.04em",
        lineHeight: 1.45
      }}>
          {item.detail}
        </p>
      </div>
    </div>;
}